export const saveResponse = {
  success: true,
};
